import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { Container } from '@mui/material';
import { CourseFormValues, useToast } from '@shared';
import { RouteEnum, coursesApi } from 'App';
import { Form } from '../Form';

const initialValues: CourseFormValues = {
  name: '',
  description: '',
  start: null,
  end: null,
};

export const Create = ({ rootPath, partnerId }: { rootPath: RouteEnum; partnerId: string }) => {
  const navigate = useNavigate();
  const toast = useToast();

  const onExit = () => navigate(rootPath);

  const { mutate: createCourse, isLoading } = useMutation({
    mutationFn: (data: CourseFormValues) => coursesApi.addCourse(partnerId, data),
    onSuccess: () => {
      toast.success('Course has been created');
      onExit();
    },
  });

  const handleSubmit = (values: CourseFormValues) => {
    createCourse(values);
  };
  return (
    <Container component='article' maxWidth='sm'>
      <Form
        onSubmit={handleSubmit}
        initialValues={initialValues}
        isLoading={isLoading}
        onExit={onExit}
        title='Create course'
        submitButtonLabel='Finish'
      />
    </Container>
  );
};
